import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white">
      <div className="space-y-8">
        <section className="border-l-4 border-blue-500 pl-6">
          <h2 className="terms-title"style={{fontSize:'16px',fontWeight:'600'}}>1. Introduction and Acceptance of Agreement</h2>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.1</span>
              <p className="">Thank you for choosing Veena World. We take all efforts to make sure that you have a delightful holiday experience. To avoid any misunderstanding, we request you to read, understand and abide by the below 'Terms and Conditions' along with Privacy Policy before you book any tour or holiday or any service or make any transaction with Veena World at any of the Veena World sales offices or at sales partner or online on Veena World's website or any mobile application or otherwise. Once you book any tour or service with Veena World, it is understood that you are giving your unqualified consent to accept and abide by the 'Terms and Conditions'. In case you disagree with any part of these 'Terms and Conditions', kindly do not proceed with the booking.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.2</span>
              <p className="">'Terms and Conditions' extend to all group tours, customized holidays, corporate tours, any other services and products for Domestic, International or Inbound organised by 'Veena Patil Hospitality Private Limited'.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.3</span>
              <p className="">Veena World has the final authority on the interpretation of these 'Terms and Conditions'.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.4</span>
              <p className="">Veena World reserves the right to amend, vary, add, amplify or waive any stipulation, representation, term or condition mentioned in the 'Terms and Conditions'.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.5</span>
              <p className="">Under any unprecedented force majeure situation or any changes in Government policy, Veena World reserves the right to supersede any part of these 'Terms and Conditions' with an alternate and valid enforceable provision.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.6</span>
              <p className="">Each of these 'Terms and Conditions' shall be severable and if any provision thereof is declared invalid, illegal or unenforceable, then remaining provisions nevertheless shall have full force & effect.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.7</span>
              <p className="">These 'Terms and Conditions', together with the other booking related terms/ communication sent periodically, represent the entire agreement between Veena World and you.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">1.8</span>
              <p className="">There is no agreement between the Company and you until the company has received the initial registration amount/ deposit as the case may be.</p>
            </div>
          </div>
        </section>
        <section className="border-l-4 border-green-500 pl-6">
          <h2 className="terms-title"style={{fontSize:'16px',fontWeight:'600'}}>2. Description</h2>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">2.1</span>
              <p className="">These 'Terms and Conditions' be called, 'Veena Patil Hospitality Private Limited Terms and Conditions' or 'Veena World Terms and Conditions'.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">2.2</span>
              <p className="">These 'Terms and Conditions' may also be referred as 'Rules and Regulations'.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">2.3</span>
              <p className="">Veena Patil Hospitality Private Limited will be hereinafter referred as 'Veena World', 'VW', 'VPHPL', 'the Company', 'the organization', 'we', 'us' or 'our' and its user will be hereinafter referred as 'Guest/s', 'them', 'they', their, 'You', 'Your', 'tourist/s', 'traveller/s', 'client/s', 'customer/s', 'pax', or 'passengers'.</p>
            </div>
            <div className='d-flex flex-row'>
              <span className="font-medium text-gray-800 me-2">2.4</span>
              <p className="">The website and the mobile applications of Veena World are collectively referred to as 'Website'.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;